import { render, staticRenderFns } from "./ConnectionPage.vue?vue&type=template&id=87aef8ce&scoped=true"
import script from "./ConnectionPage.vue?vue&type=script&lang=js"
export * from "./ConnectionPage.vue?vue&type=script&lang=js"
import style0 from "./ConnectionPage.vue?vue&type=style&index=0&id=87aef8ce&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87aef8ce",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VIcon})
